module.exports = __webpack_public_path__ + "static/media/github.1dca1c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/github.png
// module id = 103
// module chunks = 0